import { render, staticRenderFns } from "./inpfile.vue?vue&type=template&id=2bc94c56&scoped=true&"
import script from "./inpfile.vue?vue&type=script&lang=js&"
export * from "./inpfile.vue?vue&type=script&lang=js&"
import style0 from "./inpfile.vue?vue&type=style&index=0&id=2bc94c56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc94c56",
  null
  
)

export default component.exports